(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("_"), require("moment"), require("ReactDOM"), require("setimmediate"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "_", "moment", "ReactDOM", "setimmediate"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("React"), require("_"), require("moment"), require("ReactDOM"), require("setimmediate")) : factory(root["React"], root["_"], root["moment"], root["ReactDOM"], root["setimmediate"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__26__, __WEBPACK_EXTERNAL_MODULE__35__, __WEBPACK_EXTERNAL_MODULE__294__) {
return 